import { useState, useEffect } from "react";
import { Product } from "../../types/Product";
import { HttpProduct } from "../../http";
import { usePricingSessionRevision } from "../../contexts/PricingSessionContext";

export const useHomeProducts = () => {
    const pricingSessionRevision = usePricingSessionRevision();
    const [featuredProducts, setFeaturedProducts] = useState<Product[]>([]);
    const [latestProducts, setLatestProducts] = useState<Product[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;

        const fetchProducts = async () => {
            try {
                setLoading(true);
                setError(null);
                const [latestProductsData, featuredProductsData] = await Promise.all([
                    HttpProduct.getLatest(),
                    HttpProduct.getFeatured(),
                ]);

                if (cancelled) return;
                setLatestProducts(latestProductsData);
                setFeaturedProducts(featuredProductsData);
            } catch (err) {
                console.error("Error fetching products:", err);
                if (!cancelled) setError("Error al cargar los productos");
            } finally {
                if (!cancelled) setLoading(false);
            }
        };

        void fetchProducts();
        return () => {
            cancelled = true;
        };
    }, [pricingSessionRevision]);

    return {
        showcaseProducts: featuredProducts,
        novedadesProducts: latestProducts.slice(0, 5),
        loading,
        error,
    };
};
